// extracted by mini-css-extract-plugin
export default {"reaction-button":"ReactionButton__reaction-button__vpr7k","reactionButton":"ReactionButton__reaction-button__vpr7k","active":"ReactionButton__active__EANmD"};